import { render, staticRenderFns } from "./OrderOverviewModal.vue?vue&type=template&id=006f09fc&scoped=true&"
import script from "./OrderOverviewModal.vue?vue&type=script&lang=js&"
export * from "./OrderOverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverviewModal.vue?vue&type=style&index=0&id=006f09fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f09fc",
  null
  
)

export default component.exports